export default {
  props: {
    observerRoles: {
      type: Array,
      required: true
    }
  },

  computed: {
    reportTypeName () {
      var report
      this.observerRoles.forEach((role) => {
        if (role.value === 'RATING_REPORT') {
          report = role.label
        }
      })
      return report
    },

    peerTypeName () {
      var peer
      this.observerRoles.forEach((role) => {
        if (role.value === 'RATING_PEER') {
          peer = role.label
        }
      })
      return peer
    },

    bossTypeName () {
      var boss
      this.observerRoles.forEach((role) => {
        if (role.value === 'RATING_BOSS') {
          boss = role.label
        }
      })
      return boss
    }
  },

  methods: {
    getRoleLabelFromValue (value) {
      if (value === 'RATING_REPORT') {
        return this.reportTypeName
      }
      if (value === 'RATING_PEER') {
        return this.peerTypeName
      }
      if (value === 'RATING_BOSS') {
        return this.bossTypeName
      }
    }
  }
}
